/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ReposRouteImport } from './routes/repos'
import { Route as PrReviewsRouteImport } from './routes/pr-reviews'
import { Route as MemoryRouteImport } from './routes/memory'
import { Route as BriefRouteImport } from './routes/brief'
import { Route as AgentsRouteImport } from './routes/agents'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TicketsIndexRouteImport } from './routes/tickets.index'
import { Route as TicketsNewRouteImport } from './routes/tickets.new'
import { Route as TicketsKeyRouteImport } from './routes/tickets.$key'
import { Route as TicketsKeyIndexRouteImport } from './routes/tickets.$key.index'
import { Route as TicketsKeyChatRouteImport } from './routes/tickets.$key.chat'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ReposRoute = ReposRouteImport.update({
  id: '/repos',
  path: '/repos',
  getParentRoute: () => rootRouteImport,
} as any)
const PrReviewsRoute = PrReviewsRouteImport.update({
  id: '/pr-reviews',
  path: '/pr-reviews',
  getParentRoute: () => rootRouteImport,
} as any)
const MemoryRoute = MemoryRouteImport.update({
  id: '/memory',
  path: '/memory',
  getParentRoute: () => rootRouteImport,
} as any)
const BriefRoute = BriefRouteImport.update({
  id: '/brief',
  path: '/brief',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsRoute = AgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsIndexRoute = TicketsIndexRouteImport.update({
  id: '/tickets/',
  path: '/tickets/',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsNewRoute = TicketsNewRouteImport.update({
  id: '/tickets/new',
  path: '/tickets/new',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsKeyRoute = TicketsKeyRouteImport.update({
  id: '/tickets/$key',
  path: '/tickets/$key',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsKeyIndexRoute = TicketsKeyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TicketsKeyRoute,
} as any)
const TicketsKeyChatRoute = TicketsKeyChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => TicketsKeyRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/agents': typeof AgentsRoute
  '/brief': typeof BriefRoute
  '/memory': typeof MemoryRoute
  '/pr-reviews': typeof PrReviewsRoute
  '/repos': typeof ReposRoute
  '/settings': typeof SettingsRoute
  '/tickets/$key': typeof TicketsKeyRouteWithChildren
  '/tickets/new': typeof TicketsNewRoute
  '/tickets/': typeof TicketsIndexRoute
  '/tickets/$key/chat': typeof TicketsKeyChatRoute
  '/tickets/$key/': typeof TicketsKeyIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/agents': typeof AgentsRoute
  '/brief': typeof BriefRoute
  '/memory': typeof MemoryRoute
  '/pr-reviews': typeof PrReviewsRoute
  '/repos': typeof ReposRoute
  '/settings': typeof SettingsRoute
  '/tickets/new': typeof TicketsNewRoute
  '/tickets': typeof TicketsIndexRoute
  '/tickets/$key/chat': typeof TicketsKeyChatRoute
  '/tickets/$key': typeof TicketsKeyIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/agents': typeof AgentsRoute
  '/brief': typeof BriefRoute
  '/memory': typeof MemoryRoute
  '/pr-reviews': typeof PrReviewsRoute
  '/repos': typeof ReposRoute
  '/settings': typeof SettingsRoute
  '/tickets/$key': typeof TicketsKeyRouteWithChildren
  '/tickets/new': typeof TicketsNewRoute
  '/tickets/': typeof TicketsIndexRoute
  '/tickets/$key/chat': typeof TicketsKeyChatRoute
  '/tickets/$key/': typeof TicketsKeyIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/agents'
    | '/brief'
    | '/memory'
    | '/pr-reviews'
    | '/repos'
    | '/settings'
    | '/tickets/$key'
    | '/tickets/new'
    | '/tickets/'
    | '/tickets/$key/chat'
    | '/tickets/$key/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/agents'
    | '/brief'
    | '/memory'
    | '/pr-reviews'
    | '/repos'
    | '/settings'
    | '/tickets/new'
    | '/tickets'
    | '/tickets/$key/chat'
    | '/tickets/$key'
  id:
    | '__root__'
    | '/'
    | '/agents'
    | '/brief'
    | '/memory'
    | '/pr-reviews'
    | '/repos'
    | '/settings'
    | '/tickets/$key'
    | '/tickets/new'
    | '/tickets/'
    | '/tickets/$key/chat'
    | '/tickets/$key/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AgentsRoute: typeof AgentsRoute
  BriefRoute: typeof BriefRoute
  MemoryRoute: typeof MemoryRoute
  PrReviewsRoute: typeof PrReviewsRoute
  ReposRoute: typeof ReposRoute
  SettingsRoute: typeof SettingsRoute
  TicketsKeyRoute: typeof TicketsKeyRouteWithChildren
  TicketsNewRoute: typeof TicketsNewRoute
  TicketsIndexRoute: typeof TicketsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/repos': {
      id: '/repos'
      path: '/repos'
      fullPath: '/repos'
      preLoaderRoute: typeof ReposRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pr-reviews': {
      id: '/pr-reviews'
      path: '/pr-reviews'
      fullPath: '/pr-reviews'
      preLoaderRoute: typeof PrReviewsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/memory': {
      id: '/memory'
      path: '/memory'
      fullPath: '/memory'
      preLoaderRoute: typeof MemoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brief': {
      id: '/brief'
      path: '/brief'
      fullPath: '/brief'
      preLoaderRoute: typeof BriefRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents': {
      id: '/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AgentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets/': {
      id: '/tickets/'
      path: '/tickets'
      fullPath: '/tickets/'
      preLoaderRoute: typeof TicketsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets/new': {
      id: '/tickets/new'
      path: '/tickets/new'
      fullPath: '/tickets/new'
      preLoaderRoute: typeof TicketsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets/$key': {
      id: '/tickets/$key'
      path: '/tickets/$key'
      fullPath: '/tickets/$key'
      preLoaderRoute: typeof TicketsKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets/$key/': {
      id: '/tickets/$key/'
      path: '/'
      fullPath: '/tickets/$key/'
      preLoaderRoute: typeof TicketsKeyIndexRouteImport
      parentRoute: typeof TicketsKeyRoute
    }
    '/tickets/$key/chat': {
      id: '/tickets/$key/chat'
      path: '/chat'
      fullPath: '/tickets/$key/chat'
      preLoaderRoute: typeof TicketsKeyChatRouteImport
      parentRoute: typeof TicketsKeyRoute
    }
  }
}

interface TicketsKeyRouteChildren {
  TicketsKeyChatRoute: typeof TicketsKeyChatRoute
  TicketsKeyIndexRoute: typeof TicketsKeyIndexRoute
}

const TicketsKeyRouteChildren: TicketsKeyRouteChildren = {
  TicketsKeyChatRoute: TicketsKeyChatRoute,
  TicketsKeyIndexRoute: TicketsKeyIndexRoute,
}

const TicketsKeyRouteWithChildren = TicketsKeyRoute._addFileChildren(
  TicketsKeyRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AgentsRoute: AgentsRoute,
  BriefRoute: BriefRoute,
  MemoryRoute: MemoryRoute,
  PrReviewsRoute: PrReviewsRoute,
  ReposRoute: ReposRoute,
  SettingsRoute: SettingsRoute,
  TicketsKeyRoute: TicketsKeyRouteWithChildren,
  TicketsNewRoute: TicketsNewRoute,
  TicketsIndexRoute: TicketsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
